import { BookOutlined, DownOutlined, EditOutlined } from '@ant-design/icons'
import { Dropdown, Menu, MenuProps, Tooltip, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Favorite, getPointPermission, MosaicComponent, UserName } from '@/components'
import { HotResource } from '@/components/hot-resource/hot-resource.component'
import { PAGE_RESOURCE_POINTS_ENUM, ResourceType } from '@/schemas'

import { Devlop } from '../../devlop.schema'
import { DevlopEdit } from './devlop-edit.component'

interface ProjectHeaderContainerProps {
  project: Devlop
  refreshProject: () => void
}

export const DevlopHeaderContainer: React.FC<ProjectHeaderContainerProps> = ({ project: devlop, refreshProject }) => {
  const { t } = useTranslation()
  const [visible, setVisible] = React.useState(false)
  const [editVisible, setEditVisible] = React.useState(false)
  const { canUpdate } = getPointPermission(PAGE_RESOURCE_POINTS_ENUM.概况, devlop.permissions)

  const onClickMenu: MenuProps['onClick'] = ({ key }) => {
    if (key === 'edit') {
      setEditVisible(true)
      setVisible(false)
    }
  }

  // const isDone = devlop.progress === 100

  const menu = (
    <Menu onClick={onClickMenu}>
      <Menu.Item key='edit' icon={<EditOutlined />} disabled={!canUpdate}>
        {t('devlop.editInfo')}
      </Menu.Item>
    </Menu>
  )

  return (
    <div className='flex space-x-16px text-sm items-baseline max-w-full truncate'>
      <div>
        <BookOutlined style={{ fontSize: 18 }} />
      </div>
      <Dropdown trigger={['click']} overlay={menu} visible={visible} onVisibleChange={(visible) => setVisible(visible)}>
        <Typography.Text ellipsis className='cursor-pointer text-xl'>
          {devlop.name}
          <DownOutlined className='ml-4px' />
        </Typography.Text>
      </Dropdown>
      <div>
        <HotResource selfId={devlop.selfId} type={devlop.type} />
      </div>
      <div>
        <Favorite selfId={devlop.selfId} type={ResourceType.DEVLOP} isFavourited={devlop.isFavourited} />
      </div>
      <Tooltip title={t('owner')}>
        <div>
          {!getPointPermission(PAGE_RESOURCE_POINTS_ENUM.概况_负责人, devlop.permissions).canRead ? (
            <MosaicComponent />
          ) : (
            <UserName email={devlop.email} />
          )}
        </div>
      </Tooltip>

      <DevlopEdit
        devlop={devlop}
        visible={editVisible}
        onCancel={() => {
          setEditVisible(false)
          refreshProject()
        }}
      />
    </div>
  )
}
